const orikamiDomain = process.env.REACT_APP_orikamiDomain  //"newspaper-api.107.jp"
const adminDomain = process.env.REACT_APP_adminDomain    //"ato-admin-management.adx-co.jp"
const clientManagementDomain = process.env.REACT_APP_clientManagement; //  "client-management-test.adx-co.jp"
const adminPortalLogin = process.env.REACT_APP_adminPortalLogin      //"https://admin-portal.adx-co.jp./"
const  storageDomain = process.env.REACT_APP_storageDomain   //"storage-api.adx-co.jp"

export {
    orikamiDomain,
    adminDomain,
    clientManagementDomain,
    adminPortalLogin,
    storageDomain,
}
